<template>
  <div id="app">
    <template v-if="!isBot">
      <PasscodeOverlay v-if="showPasscodeOverlay" @passcode-verified="onPasscodeVerified" @stay-logged-in="handleStayLoggedIn" />
      <AdminDashboard v-else @logout="logout" />
    </template>
    <h1 v-else>Access Denied</h1>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import PasscodeOverlay from './components/PasscodeOverlay.vue';
import AdminDashboard from './components/AdminDashboard.vue';

export default {
  name: 'App',
  components: {
    PasscodeOverlay,
    AdminDashboard,
  },
  setup() {
    const showPasscodeOverlay = ref(true);
    const isBot = ref(false);

    onMounted(() => {
      // Bot detection
      if (navigator.webdriver) {
        isBot.value = true;
        window.location.href = 'https://www.google.com';
      } else {
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        if (isLoggedIn) {
          showPasscodeOverlay.value = false;
        }
      }

      // Disable right-click
      document.addEventListener("contextmenu", (event) => event.preventDefault());

      // Disable developer tools shortcuts
      document.addEventListener("keydown", (event) => {
        if (
          event.key === "F12" || 
          (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J")) || 
          (event.ctrlKey && event.key === "U")
        ) {
          event.preventDefault();
        }
      });
    });

    const onPasscodeVerified = () => {
      showPasscodeOverlay.value = false;
    };

    const handleStayLoggedIn = (stay) => {
      if (stay) {
        localStorage.setItem('isLoggedIn', 'true');
      }
    };

    const logout = () => {
      showPasscodeOverlay.value = true;
      localStorage.removeItem('isLoggedIn');
    };

    return {
      showPasscodeOverlay,
      isBot,
      onPasscodeVerified,
      handleStayLoggedIn,
      logout,
    };
  },
};
</script>

<style>
:root {
  --primary-color: #ff6b6b;
  --secondary-color: #4ecdc4;
  --accent-color: #feca57;
  --background-color: #f7f7f7;
  --text-color: #333333;
  --card-background: #ffffff;
  --card-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

body {
  background-color: var(--background-color);
  color: var(--text-color);
  font-family: 'Poppins', sans-serif;
  margin: 0;
  padding: 0;
  line-height: 1.6;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

h1 {
  text-align: center;
  color: var(--primary-color);
  margin-top: 50px;
}
</style>

